(() => {
  if (window.SSTLinkedGiftRemoveInitialized) return;
  window.SSTLinkedGiftRemoveInitialized = true;

  const root = (
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
  ) ? Shopify.routes.root : '/';

  const headers = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  async function refreshDrawer(openAfterRefresh = true) {
    const currentDrawer = document.querySelector('cart-drawer');
    if (!currentDrawer) {
      window.location.reload();
      return;
    }

    const response = await fetch(root + '?sections=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) {
      window.location.reload();
      return;
    }

    const sections = await response.json();
    const html = sections && sections['cart-drawer'];

    if (!html) {
      window.location.reload();
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = doc.querySelector('cart-drawer');

    if (!freshDrawer) {
      window.location.reload();
      return;
    }

    currentDrawer.replaceWith(freshDrawer);

    if (!openAfterRefresh) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.setAttribute('aria-hidden', 'false');
          drawer.classList.add('is-open', 'open');
          document.documentElement.classList.add('cart-drawer-open');
        }
      });
    });
  }

  async function findLinkedGiftKeys(productId, productTitle) {
    const cartResponse = await fetch(root + 'cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!cartResponse.ok) {
      throw new Error('Unable to read cart.');
    }

    const cart = await cartResponse.json();
    const giftKeys = [];

    cart.items.forEach((item) => {
      const properties = item.properties || {};
      if (properties['_sst_gift_wrap'] !== 'Yes') return;

      const parentProductId = String(properties['_sst_parent_product_id'] || '');
      const parentTitle = String(properties['For product'] || '');

      const matchesById =
        parentProductId &&
        productId &&
        parentProductId === productId;

      const matchesByTitle =
        !parentProductId &&
        parentTitle &&
        productTitle &&
        parentTitle === productTitle;

      if (matchesById || matchesByTitle) {
        giftKeys.push(item.key);
      }
    });

    return giftKeys;
  }

  async function removeLines(updates) {
    const updateResponse = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers,
      body: JSON.stringify({ updates })
    });

    if (!updateResponse.ok) {
      const error = await updateResponse.json().catch(() => ({}));
      throw new Error(error.description || 'Unable to update cart.');
    }
  }

  async function removeMainAndLinkedGift(removeLink) {
    const lineKey = removeLink.dataset.lineKey;
    const productId = String(removeLink.dataset.productId || '');
    const productTitle = removeLink.dataset.productTitle || '';
    const isGift = removeLink.dataset.isGift === 'true';

    const updates = {};
    updates[lineKey] = 0;

    if (!isGift) {
      const giftKeys = await findLinkedGiftKeys(productId, productTitle);
      giftKeys.forEach((key) => { updates[key] = 0; });
    }

    await removeLines(updates);
  }

  async function removeLinkedGiftForItem(cartItemEl) {
    const removeLink = cartItemEl.querySelector('[data-cart-remove]');
    if (!removeLink || removeLink.dataset.isGift === 'true') return;

    const productId = String(removeLink.dataset.productId || '');
    const productTitle = removeLink.dataset.productTitle || '';

    const giftKeys = await findLinkedGiftKeys(productId, productTitle);
    if (!giftKeys.length) return;

    const updates = {};
    giftKeys.forEach((key) => { updates[key] = 0; });
    await removeLines(updates);
  }

  document.addEventListener('click', async (event) => {
    const removeLink = event.target.closest('[data-cart-remove]');
    if (!removeLink) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (removeLink.dataset.removing === 'true') return;
    removeLink.dataset.removing = 'true';
    removeLink.style.pointerEvents = 'none';
    removeLink.setAttribute('aria-disabled', 'true');

    try {
      await removeMainAndLinkedGift(removeLink);

      if (window.location.pathname.replace(/\/+$/, '') === root.replace(/\/+$/, '') + 'cart') {
        window.location.reload();
      } else {
        await refreshDrawer(true);
      }
    } catch (error) {
      console.error('[SST linked gift removal]', error);
      window.location.href = removeLink.href;
    }
  }, true);

  document.addEventListener('click', (event) => {
    const quantityDown = event.target.closest('.quantity-down');
    if (!quantityDown) return;

    const cartItemEl = quantityDown.closest('.cart-item');
    if (!cartItemEl) return;

    let url;
    try {
      url = new URL(quantityDown.href, window.location.origin);
    } catch (error) {
      return;
    }

    const targetQuantity = parseInt(url.searchParams.get('quantity'), 10);
    if (targetQuantity !== 0) return;

    removeLinkedGiftForItem(cartItemEl).catch((error) => {
      console.error('[SST linked gift removal]', error);
    });
  }, true);

  document.addEventListener('change', (event) => {
    const quantityInput = event.target.closest('.cart-item__quantity-input');
    if (!quantityInput) return;

    if (parseInt(quantityInput.value, 10) !== 0) return;

    const cartItemEl = quantityInput.closest('.cart-item');
    if (!cartItemEl) return;

    removeLinkedGiftForItem(cartItemEl).catch((error) => {
      console.error('[SST linked gift removal]', error);
    });
  }, true);
})();
